// import consts
import { dynamicAssets, staticAssets, staticImageAssets } from 'js/constants/Paths';

const FALLBACK_GAME_IMAGE = staticImageAssets('images/static/540x304.png');

export const parseData = (data) => {
  const gameIds = [];
  const gamesById = {};

  if (data && data?.length > 0) {
    data.map((item) => {
      if (item.header_image && item.header_image !== '') {
        item.header_image = dynamicAssets(item.header_image);
      }

      if (item.cta_image && item.cta_image !== '') {
        item.cta_image = dynamicAssets(item.cta_image);
      }

      if (item.game_src && item.game_src !== '') {
        item.game_src = staticAssets(item.game_src);
      }

      if (item.game_seo?.image && item.game_seo.image !== '') {
        item.game_seo.image = staticAssets(item.game_seo.image);
      }

      item.default_image = FALLBACK_GAME_IMAGE;
      item.full_url = '/games/' + item.friendly_url;
      item.type = 'game';

      gameIds.push(item.id);
      gamesById[item.id] = item;
    });
  }

  return { gamesById, gameIds };
};
